const BASE_PATH = 'USERBOX_PROFILE';

export const SET_PROFILE = `${BASE_PATH}/SET_PROFILE`;
export const CLEAR_PROFILE = `${BASE_PATH}/CLEAR_PROFILE`;

export const setUserBoxProfile = (avatar, username, score, profileUrl, id) => ({
    type: SET_PROFILE,
    avatar,
    username,
    score,
    profileUrl,
    id
});

export const clearUserBoxProfile = () => ({
    type: CLEAR_PROFILE,
});

const initialState = {
    avatar: "",
    username: "",
    score: false,
    profileUrl: "",
    id : ""
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_PROFILE:
            return {
                ...state,
                avatar: action.avatar,
                username: action.username,
                score: action.score,
                profileUrl: action.profileUrl,
                id: action.id
            };
        case CLEAR_PROFILE:
            return {
                ...initialState,
            };
        default:
            break;
    }

    return state;
}